<template>
    <b-dropdown aria-role="menu" class="fields" :mobile-modal="false">
        <a class="button is-white" slot="trigger" role="button">
            <span class="icon">
                <Icon name="TableConfig" />
            </span>
            <span>{{ $t('fields') }}</span>
        </a>
        <div class="head">{{ $t('showFields') }}:</div>
        <b-dropdown-item aria-role="menu-item" custom v-for="(field, index) in defaultFields" :key="index">
            <chooseInput type="CHECKBOX" v-model="field._visible" @input="updateFields()" :label="field.label" />
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
import Icon from './../public/Icon.vue';
export default {
    name: 'fieldsButton',
    props: {
        value: { type: Array },
        fields: { type: Array },
        id: { type: String, required: true },
    },
    components: {
        Icon,
    },
    watch: {
        fields: {
            handler(newValue, oldValue) {
                this.handleFields();
            },
            deep: true,
        },
        value: {
            handler(newValue, oldValue) {
                this.syncDefaultFieldsWithValue();
            },
            deep: true,
        },
    },
    data() {
        return {
            defaultFields: [],
        };
    },
    created() {
        this.handleFields();
    },
    methods: {
        getLabel(i18nLabel) {
            return this.$t(i18nLabel) != i18nLabel ? this.$t(i18nLabel) : i18nLabel.replace('projectFields.', '');
        },
        findFieldMatch(sourceField, targetFields) {
            return targetFields.find((field) => {
                if (sourceField.id && field.id) {
                    return sourceField.id == field.id;
                } else if (sourceField.field && field.field) {
                    return sourceField.field == field.field;
                }
                return false;
            });
        },
        syncDefaultFieldsWithValue() {
            // Sync defaultFields visibility based on current value prop
            if (this.value && this.fields) {
                this.defaultFields = this.fields.map((field) => {
                    let valueField = this.findFieldMatch(field, this.value);
                    field.label = this.getLabel(field.i18nLabel);
                    return { ...field, _visible: valueField ? valueField._visible : false };
                });
            }
        },
        filterRemovedFields(savedField) {
            return this.fields.some((field) => {
                if (savedField.id) {
                    return field.id == savedField.id;
                } else if (savedField.field) {
                    return field.field == savedField.field;
                }
                return false;
            });
        },
        handleFields() {
            if (this.fields && this.fields.length > 0) {
                //fetch saved value
                var saved = localStorage.getItem(`tableFields.${this.id}`);
                saved = saved ? JSON.parse(saved) : null;

                if (!this.value || this.value.length == 0) {
                    var defaultFields = this.fields.filter((field) => {
                        return field._visible === true;
                    });

                    // Filter out saved fields that no longer exist in this.fields
                    if (saved) {
                        saved = saved.filter(this.filterRemovedFields);
                    }

                    //update default field values
                    this.defaultFields = this.fields.map((field) => {
                        let visible = false;

                        if (saved) {
                            let savedField = this.findFieldMatch(field, saved);
                            if (savedField) {
                                visible = savedField._visible;
                            } else {
                                // New field not in saved - default to field._visible
                                visible = field._visible === true;
                            }
                        } else {
                            visible = field._visible;
                        }
                        //handle i18n label, if non existing remove the object to display its given string
                        field.label = this.getLabel(field.i18nLabel);
                        return { ...field, _visible: visible };
                    });

                    // Emit only visible fields based on saved or default visibility
                    let visibleFields = this.defaultFields.filter((field) => {
                        return field._visible === true;
                    });

                    this.$emit('input', visibleFields);
                } else {
                    //value is set - need to handle new fields and remove obsolete ones
                    // But localStorage takes precedence over value prop

                    // Filter out saved fields that no longer exist in this.fields
                    if (saved) {
                        saved = saved.filter(this.filterRemovedFields);
                    }

                    // Filter out fields from value that no longer exist in this.fields
                    let validValueFields = this.value.filter(this.filterRemovedFields);

                    this.defaultFields = this.fields.map((field) => {
                        let visible = field._visible; // fallback to field default

                        // Priority 1: localStorage (user's explicit choice)
                        if (saved) {
                            let savedField = this.findFieldMatch(field, saved);
                            if (savedField) {
                                visible = savedField._visible;
                            } else {
                                // New field not in saved - use field default
                                visible = field._visible === true;
                            }
                        } else {
                            // Priority 2: value prop (if no localStorage)
                            let valueField = this.findFieldMatch(field, validValueFields);
                            if (valueField) {
                                visible = valueField._visible !== undefined ? valueField._visible : true;
                            }
                        }

                        //handle i18n label, if non existing remove the object to display its given string
                        field.label = this.getLabel(field.i18nLabel);
                        return { ...field, _visible: visible };
                    });

                    // Emit updated value including new fields with their default visibility
                    let updatedValue = this.defaultFields.filter((field) => {
                        return field._visible === true;
                    });

                    // Only emit if the value actually changed
                    if (JSON.stringify(updatedValue) !== JSON.stringify(this.value)) {
                        this.$emit('input', updatedValue);
                    }
                }
            }
        },
        updateFields() {
            // Store ALL fields with their visibility state in localStorage
            localStorage.setItem(`tableFields.${this.id}`, JSON.stringify(this.defaultFields));
            // But only emit visible fields as the value
            let value = this.defaultFields.filter((field) => {
                return field._visible === true;
            });
            this.$emit('input', value);
        },
    },
    i18n: {
        messages: {
            en: {
                fields: 'Fields',
                showFields: 'Show Fields',
            },
            fr: {
                fields: 'Données',
                showFields: 'Afficher',
            },
            nl: {
                fields: 'Gegevens',
                showFields: 'Toon',
            },
        },
    },
};
</script>
